<template>
  <div v-if="isLoanOfficerLoaded">
    <div class="text-h5 text-center mb-4">You have been invited by:
      <div class="text-h5 mx-8 font-weight-bold">
        {{ loanOfficer.firstName }}
        {{ loanOfficer.lastName }}
      </div>
    </div>
    <ApplicationForm />
  </div>
</template>

<script>
import ApplicationForm from '@/components/ApplicationForm';

export default {
  components: {
    ApplicationForm
  },
  created() {
    this.$store.dispatch('resetCalculationResults');
  },
  computed: {
    loanOfficer() {
      return this.$store.state.loanOfficer.info;
    },
    isLoanOfficerLoaded() {
      return this.$store.getters['loanOfficer/isLoanOfficerLoaded'];
    }
  }
};
</script>

<style scoped>
.wrapper {
  max-width: 800px;
  margin: 0 auto;
}
</style>
